"use strict";

exports.__esModule = true;
exports.convertRealTimeDataToEchartsFormat = exports.convertMetricsToEchartsDataItemsFormat = exports.convertHistoricalDataToEchartsFormat = void 0;
var _Metrics = require("../../Metrics");
var _timeDefinitions = require("../../timeDefinitions");
var _Utils = require("../../../Utils");
var addPaddingUntilPeriodEnd = function addPaddingUntilPeriodEnd(data, periodEnd) {
  var lastTimestamp = data.at(-1)[0];
  for (var i = lastTimestamp + _timeDefinitions.HOUR_IN_MILLIS; i < periodEnd; i += _timeDefinitions.HOUR_IN_MILLIS) {
    data.push([i]);
  }
  return data;
};
var convertHistoricalDataToEchartsFormat = exports.convertHistoricalDataToEchartsFormat = function convertHistoricalDataToEchartsFormat(rawData, metricNames, padUntilPeriodEnd, periodEnd) {
  if (rawData === void 0) {
    rawData = [];
  }
  return rawData.reduce(function (acc, result, index) {
    var metricName = metricNames[index];
    var flattened = (0, _Metrics.flattenMetricResponse)(metricName, result);
    var deviceName = "";
    flattened.forEach(function (row) {
      deviceName = row.device;
      var timestamp = new Date(row.timestamp).getTime();
      var value = metricName in row ? row[metricName] : null;
      acc[deviceName] = (0, _Utils.returnEmptyObjectIfUndefined)(acc[deviceName]);
      acc[deviceName][metricName] = (0, _Utils.returnEmptyArrayIfUndefined)(acc[deviceName][metricName]);
      acc[deviceName][metricName].push([timestamp, value]);
    });
    if (acc[deviceName] && acc[deviceName][metricName] && acc[deviceName][metricName].length > 0 && padUntilPeriodEnd) {
      acc[deviceName][metricName] = addPaddingUntilPeriodEnd(acc[deviceName][metricName], periodEnd);
    }
    return acc;
  }, {});
};
var convertRealTimeDataToEchartsFormat = exports.convertRealTimeDataToEchartsFormat = function convertRealTimeDataToEchartsFormat(rawData, padUntilPeriodEnd, periodEnd) {
  if (rawData === void 0) {
    rawData = {};
  }
  return Object.keys(rawData).reduce(function (acc, key) {
    var _key$split = key.split(":"),
      deviceUuid = _key$split[0],
      metricName = _key$split[1];
    acc[deviceUuid] = (0, _Utils.returnEmptyObjectIfUndefined)(acc[deviceUuid]);
    acc[deviceUuid][metricName] = (0, _Utils.returnEmptyArrayIfUndefined)(acc[deviceUuid][metricName]);
    if (rawData[key]) {
      rawData[key].forEach(function (valueObject) {
        return acc[deviceUuid][metricName].push([new Date(valueObject.key).getTime(), valueObject.value]);
      });
    }
    if (acc[deviceUuid][metricName].length > 0 && padUntilPeriodEnd) {
      acc[deviceUuid][metricName] = addPaddingUntilPeriodEnd(acc[deviceUuid][metricName], periodEnd);
    }
    return acc;
  }, {});
};
var convertMetricsToEchartsDataItemsFormat = exports.convertMetricsToEchartsDataItemsFormat = function convertMetricsToEchartsDataItemsFormat(metrics) {
  return metrics.map(function (metric) {
    return {
      name: metric.name,
      displayName: metric.label,
      color: metric.color,
      unit: metric.units
    };
  });
};